import React, { useState } from 'react';
import { Table, Typography, Modal, Tooltip } from 'antd';
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import { compose } from '@reduxjs/toolkit';
import DialogUnbinStation from '@page/AdminPage/ManageDepot/components/Dialogs/DialogsUnbinStation';

const { Link, Text } = Typography;

const StationTable = ({ items, depotCode, refetch }) => {
  const [station, setStation] = useState(null);
  const [openUnbin, setOpenUnbin] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation(['admin']);

  const redirectStationDetail = (stationId) => {
    navigate(`/admin/station/detail`, { state: { id: stationId } });
  };

  const redirectChargingSessionDetail = (identifier) => {
    navigate(`/admin/charging-session`, { state: { station_identifier: identifier } });
  };

  const handleOpenDialogUnbindStation = (record) => {
    setStation(record);
    setOpenUnbin(true);
  };

  const getColumns = () => [
    {
      title: 'Mã trụ',
      dataIndex: 'identifier',
      key: 'identifier',
      render: (text, record) => <Link onClick={() => redirectStationDetail(record.id)}>{text}</Link>
    },
    {
      title: 'Model',
      dataIndex: 'model',
      key: 'model'
    },
    {
      title: 'Hãng sản xuất',
      dataIndex: 'vendor',
      key: 'vendor'
    },
    {
      title: 'Serial number',
      dataIndex: 'serial_number',
      key: 'serial_number'
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'address',
      key: 'address'
    },
    {
      title: 'Hành động',
      key: 'actions',
      render: (text, record) => (
        <>
          <Tooltip title="Gỡ trụ sạc">
            <Link
              onClick={() => handleOpenDialogUnbindStation(record)}
              style={{ marginRight: '16px' }}>
              <DeleteOutlined style={{ color: '#52525B', fontSize: '18px' }} />
            </Link>
          </Tooltip>
          <Tooltip title="Xem chi tiết phiên sạc">
            <Link onClick={() => redirectChargingSessionDetail(record.identifier)}>
              <EyeOutlined style={{ color: '#52525B', fontSize: '18px' }} />
            </Link>
          </Tooltip>
        </>
      )
    }
  ];

  return (
    <>
      <DialogUnbinStation
        depotCode={depotCode}
        station={station}
        openUnbin={openUnbin}
        setOpenUnbin={setOpenUnbin}
        refetch={refetch}
      />
      <div style={{ width: '100%', overflow: 'auto', marginTop: '10px' }}>
        <Table
          style={{ marginTop: '10px' }}
          columns={getColumns()}
          dataSource={items || []}
          rowKey="identifier"
          pagination={false}
        />
      </div>
    </>
  );
};

export default compose(withPaginate)(StationTable);
